export default "__VITE_ASSET__646ef979__"